import type {
    UnitsOnlineResponse, UpdateUnitOnlinePayload, UpdateUnitOnlineResponse,
    StatusBatchPayload, StatusBatchResponse
} from "../types"
import { instance } from "./api"
import { useAuthStore } from '../stores/t-auth';

// Clave para localStorage
const STATUS_BATCH_QUEUE_KEY = 'statusBatchQueue';

function getQueueFromStorage(): StatusBatchPayload[] {
    const raw = localStorage.getItem(STATUS_BATCH_QUEUE_KEY);
    if (!raw) return [];
    try {
        return JSON.parse(raw);
    } catch {
        return [];
    }
}

function saveQueueToStorage(queue: StatusBatchPayload[]) {
    localStorage.setItem(STATUS_BATCH_QUEUE_KEY, JSON.stringify(queue));
}

function addToQueue(payload: StatusBatchPayload) {
    const queue = getQueueFromStorage();
    queue.push(payload);
    saveQueueToStorage(queue);
}

async function trySendQueue(authToken: string) {
    const queue = getQueueFromStorage();
    if (queue.length === 0) return;
    // Unificar todos los records en un solo array
    const allRecords = queue.flatMap(p => p.parameters?.records ?? []);
    if (allRecords.length === 0) return;
    try {
        await instance.post<StatusBatchResponse>("/status_batch_req", { parameters: { records: allRecords } }, {
            headers: {
                Accept: 'application/json',
                Authorization: 'Bearer ' + authToken,
                'Content-Type': 'application/json'
            }
        });
        // Si se envía correctamente, limpiar la cola
        saveQueueToStorage([]);
    } catch {
        // Si falla, mantener la cola
    }
}

async function getUnitsOnline() {
    const auth = useAuthStore();

    return await instance.get<UnitsOnlineResponse>("/units/online", {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + auth.token
        }
    });
}

async function updateUnitOnline(payload: UpdateUnitOnlinePayload) {
    const auth = useAuthStore();

    return await instance.put<UpdateUnitOnlineResponse>("/units/online", payload, {
        headers: {
            Accept: 'application/json',
            Authorization: 'Bearer ' + auth.token,
            "Content-Type": "application/json"
        }
    });
}
async function statusBatchRequest(payload: StatusBatchPayload) {
    const auth = useAuthStore();
    try {
        // Intentar enviar la cola pendiente primero
        await trySendQueue(auth.token);
        // Enviar el registro actual
        const response = await instance.post<StatusBatchResponse>("/status_batch_req", payload, {
            headers: {
                Accept: 'application/json',
                Authorization: 'Bearer ' + auth.token,
                'Content-Type': 'application/json'
            }
        });
        return response;
    } catch (error) {
        // Si falla, guardar en cola
        addToQueue(payload);
        throw error;
    }
}
// Intentar enviar la cola cuando vuelva la conectividad
window.addEventListener('online', () => {
    const auth = useAuthStore();
    trySendQueue(auth.token);
});

export default {
    getUnitsOnline,
    updateUnitOnline,
    statusBatchRequest
};